var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("保障级别管理")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "page-info": _vm.pager, loading: _vm.tableLoading },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              { staticClass: "wrap-table-info-display" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "align-left",
                    attrs: { size: "small" },
                    on: { click: _vm.loadTableData },
                  },
                  [_vm._v("刷新")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "align-left",
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.toCreate },
                  },
                  [_vm._v("新增")]
                ),
                _c("span", { staticClass: "table-info-display" }, [
                  _c("span", [_vm._v("总条数：")]),
                  _c("span", { staticClass: "alert-text ft16" }, [
                    _vm._v(_vm._s(_vm.pager.total)),
                  ]),
                ]),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("icTableColumnIndex", {
                attrs: {
                  pageIndex: _vm.pager.pageIndex,
                  pageSize: _vm.pager.pageSize,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "levelName",
                  align: "center",
                  label: "保障级别名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "discountRate",
                  align: "center",
                  label: "农副产品折扣",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(scope.row.discountRate || "-"))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "rushBuyStartTime",
                  align: "center",
                  label: "抢购时间",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " 自发布菜品时起" +
                            _vm._s(row.rushBuyStartMinute || "-") +
                            " " +
                            _vm._s(
                              _vm.rushBuyStartTimeTypeList[
                                row.rushBuyStartTimeType
                              ]
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "description", align: "center", label: "描述" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(_vm._s(row.description || "-") + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "confirm-button",
                          {
                            staticStyle: { margin: "0 10px" },
                            attrs: {
                              type: "text",
                              title: "确认要删除该保障级别？",
                            },
                            on: {
                              confirmed: function ($event) {
                                return _vm.handleDelete(scope.row.id)
                              },
                            },
                          },
                          [_c("span", [_vm._v("删除")])]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "hx-to-create-template",
          attrs: {
            title: _vm.levelParams.id ? "编辑保障级别" : "新增保障级别",
            visible: _vm.dialogVisible,
            width: "56%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetDialogForm,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dialogForm",
              attrs: {
                model: _vm.levelParams,
                rules: _vm.checkLevelParams,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "级别名称：", prop: "levelName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入级别名称", maxlength: "20" },
                    model: {
                      value: _vm.levelParams.levelName,
                      callback: function ($$v) {
                        _vm.$set(_vm.levelParams, "levelName", $$v)
                      },
                      expression: "levelParams.levelName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "农副产品折扣：", prop: "discountRate" } },
                [
                  _c("el-input-number", {
                    attrs: { precision: 2, step: 0.1, min: 0, max: 10 },
                    model: {
                      value: _vm.levelParams.discountRate,
                      callback: function ($$v) {
                        _vm.$set(_vm.levelParams, "discountRate", $$v)
                      },
                      expression: "levelParams.discountRate",
                    },
                  }),
                  _c("span", { staticClass: "mgl10" }, [_vm._v("折")]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "首次库存比例", prop: "stockProportion" } },
                [
                  _c("el-input-number", {
                    attrs: { precision: 1, step: 1, min: 0, max: 100 },
                    model: {
                      value: _vm.levelParams.stockProportion,
                      callback: function ($$v) {
                        _vm.$set(_vm.levelParams, "stockProportion", $$v)
                      },
                      expression: "levelParams.stockProportion",
                    },
                  }),
                  _c("span", { staticClass: "mgl10" }, [_vm._v("%")]),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "补菜库存比例",
                    prop: "replenishStockProportion",
                  },
                },
                [
                  _c("el-input-number", {
                    attrs: { precision: 1, step: 1, min: 0, max: 100 },
                    model: {
                      value: _vm.levelParams.replenishStockProportion,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.levelParams,
                          "replenishStockProportion",
                          $$v
                        )
                      },
                      expression: "levelParams.replenishStockProportion",
                    },
                  }),
                  _c("span", { staticClass: "mgl10" }, [_vm._v("%")]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "时间", prop: "rushBuyStartTimeType" } },
                [
                  [
                    _c(
                      "el-radio",
                      {
                        attrs: { label: 10 },
                        model: {
                          value: _vm.levelParams.rushBuyStartTimeType,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.levelParams,
                              "rushBuyStartTimeType",
                              _vm._n($$v)
                            )
                          },
                          expression: "levelParams.rushBuyStartTimeType",
                        },
                      },
                      [_vm._v("时")]
                    ),
                    _c(
                      "el-radio",
                      {
                        attrs: { label: 20 },
                        model: {
                          value: _vm.levelParams.rushBuyStartTimeType,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.levelParams,
                              "rushBuyStartTimeType",
                              _vm._n($$v)
                            )
                          },
                          expression: "levelParams.rushBuyStartTimeType",
                        },
                      },
                      [_vm._v("分钟")]
                    ),
                    _c(
                      "el-radio",
                      {
                        attrs: { label: 30 },
                        model: {
                          value: _vm.levelParams.rushBuyStartTimeType,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.levelParams,
                              "rushBuyStartTimeType",
                              _vm._n($$v)
                            )
                          },
                          expression: "levelParams.rushBuyStartTimeType",
                        },
                      },
                      [_vm._v("天")]
                    ),
                  ],
                ],
                2
              ),
              _c(
                "el-form-item",
                { attrs: { label: "购买时段：", prop: "rushBuyStartMinute" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "请输入购买时段" },
                    model: {
                      value: _vm.levelParams.rushBuyStartMinute,
                      callback: function ($$v) {
                        _vm.$set(_vm.levelParams, "rushBuyStartMinute", $$v)
                      },
                      expression: "levelParams.rushBuyStartMinute",
                    },
                  }),
                  _c("span", { staticClass: "mgl10" }, [
                    _vm._v(
                      _vm._s(
                        _vm.rushBuyStartTimeTypeList[
                          _vm.levelParams.rushBuyStartTimeType
                        ]
                      )
                    ),
                  ]),
                  _c(
                    "span",
                    {
                      staticStyle: { color: "#f56c6c", "padding-left": "10px" },
                    },
                    [
                      _c("i", { staticClass: "el-icon-info" }),
                      _vm._v(" 菜品发布当日生效 "),
                    ]
                  ),
                ],
                1
              ),
              _c("el-form-item", [
                _c("p", { staticStyle: { color: "red" } }, [
                  _vm._v(
                    " 1、购买时段，可设置每个领货日往后延多少 " +
                      _vm._s(
                        _vm.rushBuyStartTimeTypeList[
                          _vm.levelParams.rushBuyStartTimeType
                        ]
                      ) +
                      " ，才允许其当前用户库进行菜品售卖 "
                  ),
                ]),
                _c("p", { staticStyle: { color: "red" } }, [
                  _vm._v("2、默认为“0”时，即领货日即可购买"),
                ]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "描述：", prop: "description" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入描述",
                      maxlength: "60",
                    },
                    model: {
                      value: _vm.levelParams.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.levelParams, "description", $$v)
                      },
                      expression: "levelParams.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "align-center" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: _vm.isDisabled,
                        size: "small",
                        type: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleSave()
                        },
                      },
                    },
                    [_vm._v("保 存")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }